import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasTestLessonsTable from './BodmasTestLessonsTable';
const BodmasTestLessons = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Bodmas Test Series Lesson' parent='Bodmas Test Series Lesson'  />
      <Container fluid={true}>
        <Row>
          <BodmasTestLessonsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasTestLessons;
